import { Directive, ElementRef, Input, NgZone, OnInit } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[inputAutocompletePositioning]', standalone: false })
export class InputAutocompletePositioningDirective implements OnInit {
  @Input() public mode: 'close' | 'repositioning';

  public constructor(
    private readonly ngZone: NgZone,
    private readonly host: ElementRef,
    private readonly matAutocompleteTrigger: MatAutocompleteTrigger,
  ) {}

  public ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(window, 'scroll', { passive: true, capture: true })
        .pipe(
          filter(
            (event) =>
              event.target !== this.matAutocompleteTrigger?.autocomplete?.panel?.nativeElement &&
              event.target !== this.host.nativeElement &&
              this.matAutocompleteTrigger?.panelOpen,
          ),
          untilDestroyed(this),
        )
        .subscribe(() => this.scrollPositioning());
    });
  }
  private scrollPositioning(): void {
    if (this.mode === 'close') {
      this.matAutocompleteTrigger.closePanel();
    } else if (this.mode === 'repositioning') {
      this.matAutocompleteTrigger.updatePosition();
    }
  }
}
